// What a guest has typed and calculated at checkout, kept across signing in —
// including a Google / Apple round trip that reloads the page. sessionStorage:
// this tab only, gone when it closes, never sent anywhere. The cart itself
// already lives in localStorage (marketCart.js).
//
//   draft  — the delivery form as typed (AddressBook values)
//   quote  — { id, guest_token, expires_at, keys } of the guest's calculated total
//   resume — true once "Complete purchase" was pressed and sign-in started
//
// The guest token is what lets the server attach the quote to the account
// after sign-in; it is worthless without that browser's sign-in and expires
// with the quote (15 min).

const KEY = 'maabar_checkout_v1';
const MAX_AGE_MS = 3 * 60 * 60 * 1000;

export function loadCheckoutState() {
  try {
    const s = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
    if (!s || typeof s !== 'object' || Date.now() - Number(s.savedAt || 0) > MAX_AGE_MS) return {};
    return s;
  } catch { return {}; }
}

export function saveCheckoutState(patch) {
  try {
    const next = { ...loadCheckoutState(), ...patch, savedAt: Date.now() };
    window.sessionStorage.setItem(KEY, JSON.stringify(next));
    return next;
  } catch { return null; }
}

export function clearCheckoutState() {
  try { window.sessionStorage.removeItem(KEY); } catch { /* private mode */ }
}
